import { makeToastWarning } from '@/utils/common';
import {
  MISSING_MANAGER_ASSISTANT_WARNING_MESSAGE,
  isMissingManagerAndAssistant,
} from '@/view/pages/bills/utils/constants';

/**
 * Dùng chung cho màn hóa đơn bán lẻ và B2B: tự điền nhân viên theo cấu hình ca
 * và cảnh báo khi ca chưa cấu hình hoặc trống cả QLCH/TLCH.
 * Yêu cầu component có `mainModel.billEmployeeInfo`, `mainModel.editable`, `shiftWorkConfig`.
 */
export default {
  data() {
    return { shiftWorkWarningKey: null };
  },
  methods: {
    // Chỉ điền khi tạo mới: hóa đơn cũ mà điền thì Lưu sẽ ghi thêm người không ai chọn
    fillEmptyEmployeeByShiftWork() {
      if (
        !this.shiftWorkConfig ||
        this.mainModel.id ||
        !this.mainModel.editable
      ) {
        return;
      }
      for (const jobTitle in this.mainModel.billEmployeeInfo) {
        if (
          !this.mainModel.billEmployeeInfo[jobTitle] &&
          jobTitle !== 'saleId' &&
          jobTitle !== 'saleName'
        ) {
          this.mainModel.billEmployeeInfo[jobTitle] =
            this.shiftWorkConfig[jobTitle];
        }
      }
    },
    // Trang gọi lấy cấu hình ca nhiều lần khi mở hóa đơn, chỉ cảnh báo một lần cho mỗi cửa hàng + giờ
    warnMissingShiftWorkManager({ storeId, billCreatedAt }) {
      const warningKey = `${storeId}-${billCreatedAt}`;
      if (
        !this.mainModel.editable ||
        this.shiftWorkWarningKey === warningKey ||
        !isMissingManagerAndAssistant(this.shiftWorkConfig) ||
        !isMissingManagerAndAssistant(this.mainModel.billEmployeeInfo)
      ) {
        return;
      }
      this.shiftWorkWarningKey = warningKey;
      makeToastWarning(MISSING_MANAGER_ASSISTANT_WARNING_MESSAGE);
    },
  },
};
